import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Link from '@material-ui/core/Link'
import Typography from '@naturacosmeticos/natds-web/dist/Components/Typography'
import { IntlProvider } from 'react-intl'
import Header from '../components/Header/Header'
import Main from '../components/Main'
import Logo, { LogoBeautyConsulting } from '../components/Logo'
import SEO from '../components/SEO'
import localePropTypes from '../types/localePropTypes'
import useLayoutQuery from '../hooks/useLayoutQuery'
import locationPropTypes from '../types/locationPropTypes'
import getLangKey from '../../locales/langKey'
import useDataLayer from '../hooks/useDataLayer'
import oldIcon from '../../resources/assets/images/pwa-logo.png'
import newIcon from '../../resources/assets/images/consultoria-favicon.ico'

const PureLayout = ({
  children,
  data: { site },
  location,
  i18nMessages,
  langKey,
  isEmptyHeader,
  isEloThemeActive
}) => {
  useEffect(() => {

    const dataLayer = useDataLayer()

    dataLayer.push({
      event: 'virtualPageView',
      pageViewUrl: location.pathname
    })
  }, [])

  const countryNewIcon = {
    es_PE: newIcon,
    es_CO: newIcon,
    es_CL: newIcon,
    es_EC: newIcon,
  };

  const icon = countryNewIcon[langKey] || oldIcon;
  const logo = getLogoByCountry()

  function getLogoByCountry() {
    if (langKey === 'es_MX') {
      return <Logo />
    } else {
      return isEloThemeActive ? <LogoBeautyConsulting /> : <Logo />
    }
  }

  return (
    <IntlProvider locale={getLangKey(site, location)} messages={i18nMessages}>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <SEO langKey={langKey} iconUrl={icon} />
      <Typography variant="srOnly">
        <Link href="#content">Pular para o conteúdo</Link>
      </Typography>
      <Header homeURL={location.pathname} logoImage={logo} isEmpty={isEmptyHeader} isEloThemeActive={isEloThemeActive} />
      <Main id="content">{children}</Main>
    </IntlProvider>
  )
}

const propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape(locationPropTypes),
  i18nMessages: PropTypes.object,
  isEmptyHeader: PropTypes.bool,
  isEloThemeActive: PropTypes.bool
}

PureLayout.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        languages: PropTypes.shape(localePropTypes)
      })
    })
  }).isRequired,
  ...propTypes
}

const Layout = ({
  children,
  location,
  i18nMessages,
  langKey,
  isEloThemeActive,
  ...otherProps
}) => (
  <PureLayout
    data={useLayoutQuery()}
    i18nMessages={i18nMessages}
    location={location}
    langKey={langKey}
    isEloThemeActive={isEloThemeActive}
    {...otherProps}
  >
    {children}
  </PureLayout>
)

Layout.propTypes = propTypes

export default Layout
